
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/recruitment-privacy",
      function () {
        return require("private-next-pages/services/recruitment-privacy.tsx");
      }
    ]);
  